import { h, type VNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { useModalsStore } from "@/stores/modals/modalsStore";

interface DeleteConfirmOptions {
  title?: string;
  content?: string | VNode;
  okText?: string;
  cancelText?: string;
  okType?: "primary" | "default" | "dashed" | "danger" | "link";
  centered?: boolean;
  maskClosable?: boolean;
  onOk?: () => void;
  onCancel?: () => void;
}

export const showConfirm = (options: DeleteConfirmOptions) => {
  const {
    title = "Подтвердите действие",
    content = "",
    okText = "Подтвердить",
    cancelText = "Отмена",
    okType = "danger",
    centered = true,
    maskClosable = true,
    onOk = () => console.log("OK"),
    onCancel = () => console.log("Cancel"),
  } = options;

  const modalsStore = useModalsStore();

  modalsStore.modal.confirm({
    title,
    icon: h(ExclamationCircleOutlined),
    content,
    okText,
    cancelText,
    okType,
    centered,
    maskClosable,
    onOk,
    onCancel,
  });
};
